const DEFAULT_OSS_BASE = 'https://hrws.s3.cn-east-2.jdcloud-oss.com'
const OSS_BASE = (process.env.VUE_APP_OSS_BASE || DEFAULT_OSS_BASE).replace(/\/+$/, '')

export function oss(path) {
  if (!path) return ''
  const raw = String(path)
  if (/^https?:\/\//i.test(raw)) return raw
  const normalized = raw.replace(/^\/+/, '')
  return `${OSS_BASE}/${normalized}`
}

export { OSS_BASE }
